var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Oops!")]),_c('h3',[_vm._v(_vm._s(_vm.resource)+" werd niet gevonden.")]),_c('router-link',{attrs:{"to":{ name: 'list' }}},[_vm._v("Terug naar homepage")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }